export type Role = 'VIEWER' | 'REVIEWER' | 'ADMINISTRATOR';

export const ROLE_LABELS: Record<Role, string> = {
  VIEWER: 'Viewer',
  REVIEWER: 'Reviewer',
  ADMINISTRATOR: 'Administrator',
};

/** What /api/auth/me reports: read from the database on every call. */
export interface Me {
  userId: string;
  email: string;
  displayName: string;
  role: Role;
  /** May open the back office and act on applications. */
  canReview: boolean;
  canAdminister: boolean;
}

export interface SessionResponse {
  token: string;
  me: Me;
}
